import React from 'react';
import * as interaction from '../util/interaction';
import { history } from '../history/history';
import { domain, axiosInstnace } from '../util/util';
import {
  LOGIN,
  CLEAR_ERROR,
  NEAREST_LOCATION,
  CITY_STATE,
  STATE,
  AUDIO,
  ADMIN_LOGIN,
  LOAD_AUTH_INFO
} from './user_action_types';

import {
  setAdminData,
  getAdminData
} from '../util/util';
import  {sidebarForRole} from '../../config/sidebarForRole'
export const getNearestLocation = (latitude, longitude) => async dispatch => {
  const nearestLocation = await interaction.getNearestLocation(latitude, longitude);
  dispatch({
    type: NEAREST_LOCATION,
    payload: { nearestLocation }
  });
}

export const audio = audiolength => async dispatch => {
  const audio = await interaction.audio(audiolength);
  dispatch({
    type: AUDIO,
    payload: { audio }
  });
}

export const adminLogin = params => async dispatch => {
  console.log('Admin login');
  const adminData = await interaction.adminLogin(params);
  dispatch({
    type: ADMIN_LOGIN,
    payload: { data: adminData.data }
  });
  if (adminData.message && adminData.message.length > 0 && adminData.error === "Unauthorized") {
    localStorage.removeItem('adminInfo');
    dispatch({
      type: ADMIN_LOGIN,
      payload: { errorMessage: adminData.message }
    });
  }
  if (adminData.message && adminData.message.length > 0 && adminData.error === "Not Found") {
    localStorage.removeItem('adminInfo');

    dispatch({
      type: ADMIN_LOGIN,
      payload: { errorMessage: adminData.message }
    });
  }
  if (adminData.statusCode === 200 && (adminData.data.role.includes('admin')||(adminData.data.role == 'salesUser') || adminData.data.role.includes('Admin'))) {
    setAdminData(adminData.data);
    console.log(adminData.data);
    if(sidebarForRole[adminData.data.role]){
        history.push(sidebarForRole[adminData.data.role].default)
    }else{
      history.push(sidebarForRole.user.default)
    }
  }
};

export const getCityState = () => async dispatch => {
  let cityState = await interaction.getCityState();
  let stateList = new Set()
  cityState.map(s =>
    stateList.add(s.state)
  )

  stateList = Array.from(stateList);
  cityState = cityState.map(s => ({
    name: s.state,
    value: s._id
  }));

  dispatch({
    type: CITY_STATE,
    payload: { cityState }
  });
  dispatch({
    type: STATE,
    payload: { stateList }
  });
}

export const getState = () => async dispatch => {
  let cityState = await interaction.getState();
  let stateList = new Set()
  cityState.map(s =>
    stateList.add(s)
  )

  stateList = Array.from(stateList);
  dispatch({
    type: STATE,
    payload: { stateList }
  });
}



// WEBPACK FOOTER //
// ./web/action/user_action.jsx